import { render, staticRenderFns } from "./PICSpeseDipendenti.vue?vue&type=template&id=02956b58&scoped=true"
import script from "./PICSpeseDipendenti.vue?vue&type=script&lang=js"
export * from "./PICSpeseDipendenti.vue?vue&type=script&lang=js"
import style0 from "./PICSpeseDipendenti.vue?vue&type=style&index=0&id=02956b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02956b58",
  null
  
)

export default component.exports